class CartWatcher {

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      if (quantity != 0) {
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
      }
    });

    return result;
  }

  async emitCartChanges() {
    try {
      const currentCart = await this.fetchCart();
      const oldCart = this.storedCart();
      
      const updatedCart = await this.fetchCart();

      const isGiftMembershipInCart = updatedCart.items.some(item => item.product_type?.toLowerCase().includes("gift membership"));
      const membershipATC = document.querySelectorAll('.gift-membership-add');
      const membershipBuyNow = document.querySelectorAll('.product-thumbnail__button');

      if (isGiftMembershipInCart) {
            membershipATC.forEach(button => {
                button.disabled = true;
                button.classList.add('disabled');
            });
            membershipBuyNow.forEach(button => {
                button.disabled = true;
                button.classList.add('disabled');
            });

      } else {
            membershipATC.forEach(button => {
                button.disabled = false;
                button.classList.remove('disabled');
            });  
            membershipBuyNow.forEach(button => {
                button.disabled = false;
                button.classList.remove('disabled');
            });    

      }

      const changes = this.findCartChanges(oldCart, updatedCart);

      const event = new CustomEvent("cart_changed", { detail: changes });
      window.dispatchEvent(event);

      this.storeCart(updatedCart);
    } catch (err) {
      console.error('[CartWatcher] emitCartChanges error:', err);
    }
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

const myCartWatcher = new CartWatcher();
myCartWatcher.init();
window.addEventListener("cart_changed", async (cart) => {
  console.log("Added/Removed items:", cart.detail);

    const modal = await waitForGiftMembershipElement();


  const { added = [], removed = [] } = cart.detail;

  const addedGift = added.some(item => item.product_type === 'Gift Membership');
  if (addedGift) {

    const currentCartData = await fetch('/cart.js');
    const currentCartDataJson = await currentCartData.json();
    const giftItem = currentCartDataJson.items.find(item => item.product_type === 'Gift Membership');
    if (!giftItem.properties || !giftItem.properties.recipient_email) {
       if (!(modal instanceof GiftMembership)) {
          customElements.upgrade(modal);
      }
      modal.openModal();
    }
  }

  const removedGift = removed.some(item => item.product_type === 'Gift Membership');
  if (removedGift) {
    modal.closeModal();
  }
});

async function waitForGiftMembershipElement(timeout = 5000) {
  const start = Date.now();

  while (Date.now() - start < timeout) {
    const modal = document.querySelector('gift-membership');
    if (modal && modal.openModal) return modal;
    await new Promise(r => setTimeout(r, 100));
  }
  return null;
}

